export default {
  designSummaryRedo: 'Rehacer el resumen con IA',
  designSummaryRedoConfirm: 'Se reescribirá el resumen a partir del diseño tal como está hoy. El texto actual se reemplaza; las actividades y evaluaciones no se tocan.',
  // ========== Encabezado ==========
  title: 'Diseño Instruccional',
  method: 'Modelo',
  methodPlaceholder: 'Seleccione un modelo',
  methodNone: 'Sin modelo definido',
  methodTooltip:
    'Modelo instruccional con el que se trabaja esta asignatura. Define los momentos disponibles.',
  methodsEmpty: 'No hay modelos instruccionales creados.',
  methodUpdated: 'Modelo actualizado.',

  // ========== Estados ==========
  // E28 · Los cinco estados fijos pasaron a ser un catálogo por institución
  // (InstructionalStatus). El único texto que queda acá es el de la pieza que no
  // tiene estado, que no es un estado del catálogo sino su ausencia.
  statusNotStarted: 'No iniciado',

  // ========== Tabla resumen ==========
  summaryTitle: 'Resumen del Diseño Instruccional',
  summaryWeek: 'Semana',
  summaryStudyUnits: 'Unidades de Estudio',
  summaryIndicators: 'Indicadores',
  summaryActivities: 'Actividades',
  summaryStatus: 'Estado',
  summaryWeighing: 'Ponderación',
  // E24: la tabla lista Actividades del DI y evaluaciones del Programa.
  summaryActivityOrEvaluation: '{activity} / {evaluation}',
  summaryEmpty: 'Aún no hay {entity} en este diseño instruccional.',
  summaryNoStudyUnits: 'Sin {entity} asignadas',

  // ========== Contenedores (nombre alternativo: manual.instructional_design.container) ==========
  modulesTitle: '{entity} de Contenidos',
  moduleTitleField: 'Título',
  moduleDescriptionField: 'Descripción',
  moduleTitlePlaceholder: 'Ej: {entity} 1 · Fundamentos',
  moduleUntitled: '{entity} sin título',
  moduleNoActivities: 'Esta {entity} todavía no tiene {activities}. Crea una para empezar.',
  moduleDeleteKeepsActivities: 'Las {count} {activities} que contiene NO se eliminan: quedan sin {container}, en el bloque de sin ubicar, y se pueden volver a arrastrar. Sus instrumentos y calificaciones no se tocan.',
  moduleStudyUnitsAuto: 'Las {study_unit} de la {entity} se deducen de los {indicator} de las actividades y evaluaciones que contenga.',
  studyUnitFallback: 'Unidad {order}',
  moduleStudyUnitsEmpty: 'Se mostrarán al ubicar {entity} aquí',

  // ========== Actividades (nombre alternativo: manual.instructional_design.activity) ==========
  activitiesTitle: 'Actividades por Momento',
  activitiesWithoutModule: '{activity} sin {container}',
  activityNoModule: 'Sin {entity}',
  activityEmpty:
    'Aún no hay {entity}. Crea la primera: elige sus Unidades de Estudio y sus Indicadores de Logro, y el resto se arma solo.',
  activityUntitled: '{entity} sin título',
  activityTitleField: 'Título',
  activityHoursField: 'Horas',
  activityAutonomousHoursField: 'Horas autónomas',
  activityAutonomousHoursTooltip:
    'Trabajo autónomo del estudiante (preparación y/o ejecución). Ocurre dentro de la misma semana: no la hace avanzar.',
  activityWeek: 'Semana {week}',
  activityWeekRange: 'Semanas {from}-{to}',
  activityWeekTooltip: 'Semana calculada acumulando las horas de aula de las {activities} anteriores del diseño.',
  activityWeekOverflow: 'Esta {activity} cae fuera de las semanas que tiene la {matter}. Revise las horas del diseño.',
  activityWeekMissingNoHours: 'Sin semana: falta indicar las horas',
  activityWeekMissingChainBroken: 'Sin semana: una {activity} anterior no tiene horas',
  activityWeekMissingNoClassroomHours:
    'Sin semana: la asignatura no tiene horas pedagógicas cargadas',
  activityParticipationField: 'Participación',
  activityStudentInstructions: 'Instrucciones para el estudiante',
  activityProfessorInstructions: 'Instrucciones para el docente',
  activityOrientation: 'Orientación',
  activityOrientationEmpty: 'Sin orientación. Haz clic para escribirla.',
  activityOrientationEdit: 'Editar la orientación',
  activityAttachedFiles: 'Archivos Adjuntos',
  activityAttachedFilesEmpty: 'Sin archivos adjuntos.',
  activityIndexModule: 'M{order}',
  designSummary: 'Resumen del diseño',
  designSummaryEmpty: 'Sin resumen. Haz clic para describir la metodología, cómo se evalúa y el rol del estudiante.',
  designSummaryEdit: 'Editar el resumen del diseño',
  descriptor: 'Descriptor',
  descriptorsTitle: 'Descriptores',
  descriptorsHint: 'Bloques de texto libre para lo que el diseño no tiene un campo propio. El título se agrega al catálogo de la institución y queda disponible para otros diseños; el contenido es de este diseño.',
  descriptorsTopTitle: 'Descriptores al inicio',
  descriptorsTopHint: 'Lo mismo que los Descriptores del final, pero antes del recorrido: para lo que se lee primero, como un encuadre o un aviso. El título se agrega al catálogo de la institución y queda disponible para otros diseños; el contenido es de este diseño. Cada título pertenece a una sola zona.',
  activityDescriptorsTitle: 'Descriptores',
  activityDescriptorsHint: 'Campos extra para esta actividad: un video, un enlace, un texto más, lo que necesites y no tenga un campo propio. Le pones el título que quieras y agregas los que quieras. El título se guarda en el catálogo de la institución; el contenido es de esta actividad.',
  activityIndicators: 'Indicadores de Logro',
  activityContents: 'Contenidos',
  referencedEvaluationTooltip: '{evaluation} creada en el {program}. El Diseño Instruccional la ubica en la secuencia.',
  referencedEvaluationOrigin: 'Esta {evaluation} se define en el {program}. Acá se decide dónde va en la secuencia de aprendizaje.',
  activityMomentsField: 'Momentos que activa',
  activityMomentsHint: 'Una {activity} puede activar varios momentos a la vez: no son pasos separados sino fases interconectadas. Su lugar en la secuencia lo define el orden dentro de la {container}, no el momento.',
  activityMomentsGuide: 'Ver los momentos de este modelo y su descripción',
  activityListEmpty: 'Sin {entity}.',
  activityStrategiesEmpty: 'La institución aún no tiene {entity} cargadas.',
  activityStrategiesMatter: 'Declarada como mínima para la {entity}.',
  activityStrategiesNone: 'Sin {entity} seleccionadas.',
  activityStrategiesCreateWarning:
    'Se agrega al catálogo de la institución: quedará disponible en todas las asignaturas, también en el Programa y en la Planificación.',
  activityEvidencesEmpty: 'La institución aún no tiene {entity} cargadas.',
  activityEvidencesHint: 'Qué produce el estudiante con esta {entity}. Se elige del catálogo de la institución; para agregar una nueva, se administra en su propia vista.',
  activityContentsEmpty: 'Seleccione primero los {indicator}: los contenidos disponibles son los de sus {study_unit}.',
  activityNoDescription: 'Sin descripción',
  activityNoInstructions: 'Sin instrucciones',
  participationIndividual: 'Individual',
  participationPairs: 'Parejas',
  participationGroup: 'Grupal',
  activityInstrumentMissing: 'La {evaluation} asociada a esta {activity} ya no existe.',
  activityGoTo: 'Ir a la {entity}',
  activityGoToTooltip: 'Abrir la {entity} para editar sus preguntas',
  activityDeleteFromProgramWarning: 'Esta {evaluation} es una {entity} del Diseño Instruccional: también se eliminará de ahí.',

  // ========== Bibliografía de la actividad ==========

  // ========== Cobertura ==========
  coverageTitle: 'Pendientes de cobertura',
  coverageUsageTitle: 'Uso de {entity} en el diseño',
  coverageUsageExpand:
    'Ver con qué se trabaja y se evalúa, y qué produce el estudiante',
  coherenceTaughtWith: 'Se trabaja en',
  coherenceEvaluatedWith: 'Se evalúa en',
  coherenceNoStrategies: 'Sin estrategias declaradas',
  coherenceEvaluatedNotTaught: 'Este {entity} se evalúa, pero ninguna {activity} del diseño lo trabaja.',
  coherenceTaughtNotEvaluated: 'Este {entity} se trabaja, pero ninguna {evaluation} lo mide.',
  coherenceSharedStrategies: 'En común: {names}',
  coherenceNoSharedStrategies:
    'Lo que se trabaja y lo que se evalúa no comparten ninguna estrategia. No es necesariamente un problema —se puede enseñar con una y evaluar con otra—, pero conviene revisar que el nivel de exigencia sea el mismo.',
  coherenceNoEvidences: 'Sin evidencias declaradas',
  coherenceSharedEvidences:
    'Lo que se produce es lo que se evalúa: {names}.',
  coherenceMoments: 'Momentos del modelo que se trabajan aquí:',
  coherenceNoSharedEvidences: 'Lo que el estudiante produce trabajando no es lo que la {evaluation} le pide producir. Puede ser deliberado, pero conviene revisar que haya practicado el producto con el que se lo mide.',
  coverageNoIndicators: 'La {matter} no tiene {entity} definidos en su Programa.',
  // E39 · Estado del Diseño: el bloque que resume tamaño y cobertura.
  statsTitle: 'Estado del Diseño',
  statsNumbersTitle: 'El diseño en números',
  statsAnd: 'y',
  statsCoverageTitle: 'Cobertura',
  statsOutOf: '{used} de {total}',
  statsPiecesSplit: '{activities} {activity_label} · {evaluations} {evaluation_label}',
  statsHours: 'Horas pedagógicas',
  statsWeeks: 'Semanas ocupadas',
  statsWeeksOverflow: 'Se pasa del total de la {matter}',
  statsWeighing: 'Ponderación acumulada',
  statsWeighingOff: 'No suma 100%',
  statsOk: 'Correcta',
  statsSequence: 'Piezas que respetan la secuencia del modelo',
  statsSequenceDetail:
    'Un modelo instruccional es un recorrido: una pieza no debería empezar en un momento al que el diseño todavía no llegó.',
  statsSequenceSkips: 'se saltea {moments}',
  statsMomentsDistribution: 'Cuántas {entity} cumple cada momento',

  // E48 · El análisis IA de la triangulación de la tabla de cobertura.
  triangulationAiButton: 'Analizar con IA',
  triangulationAiTooltip:
    'Revisa con IA si lo que se trabaja, lo que se evalúa y lo que se declara hablan del mismo aprendizaje.',
  triangulationAiTitle: 'Análisis de la triangulación del Diseño Instruccional',
  statsPiecesComplete: '{entity} completas',
  statsPiecesCompleteDetail:
    'Declaran las tres cosas: {entity1}, {entity2} y {entity3}.',
  statsUnitsOverlap: '{entity} donde se trabaja lo que se evalúa',
  statsUnitsOverlapDetail: 'La {activity} y la {evaluation} de la {study_unit} comparten al menos una {entity1} o una {entity2}. Sólo se cuentan las {study_units} que tienen los dos lados declarados.',
  statsLacks: 'sin',
  statsMissingTitle: 'Faltan:',

  // ========== Momentos ==========
  momentNone: 'Sin momento asignado',
  moduleMomentsIncomplete:
    'La secuencia del modelo queda interrumpida en este {container}: falta trabajar {moments}.',
  moduleClosingMomentMissing:
    'Este {container} es el cierre del curso y no llega a {moment}: la secuencia del modelo queda sin cerrar.',
  momentEmpty: 'Sin actividades en este momento.',
  momentsMissing:
    'Seleccione un modelo instruccional con sus momentos definidos para armar el diseño.',

  // ========== Mensajes ==========
  loadError:
    'No fue posible cargar el diseño instruccional. Intente nuevamente más tarde.',
  saveError: 'No fue posible guardar los cambios. Intente nuevamente.',
  saved: 'Cambios guardados.',

  // ========== Borrado de una actividad-evaluación (E16) ==========
  activityDeleteEvaluationWarning: 'Se eliminará también la {evaluation} de esta {activity}, con sus instrumentos y preguntas. Las {evaluations} ya replicadas a las secciones no se tocan.',
};
